<template>
    <div>
      No matching route found.
    </div>
</template>
<script>
export default {
  mounted() {
    this.$router.push('/applicationList')
  }
}
</script>
